import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import Olasupo from "../../../assets/shortlist_23/olasupo.png";
import Jabir from "../../../assets/shortlist_23/jabir.png";
import Osariemen from "../../../assets/shortlist_23/osariemen.png";
import Nwabueze from "../../../assets/shortlist_23/nwabueze.png";

const civicNominees = [
  {
    name: "Abideen Olasupo",
    title: "Brain Builder Youth development Initiative",
    imgpath: Olasupo,
  },
  {
    name: "Jabir Yahya Zakari",
    title:
      " Change Initiative for Development Empowerment and Leadership - CITADEL",
    imgpath: Jabir,
  },
  {
    name: "Nwabueze Chibuzor Godfirst",
    title: "Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH",
    imgpath: Nwabueze,
  },
  {
    name: "Osariemen Grace Omoruyi",
    title: "Restorative Justice for Africa Initiative",
    imgpath: Osariemen,
  },
];

const CivicNominees = () => {
  return (
    <Grid
      item
      xs={12}
      md={12}
      marginTop={{ xs: "10%", sm: "3%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant={"h5"}
        fontWeight={400}
        paddingBottom={"2%"}
        color={"#049593"}
      >
        Award for Civic Activism (Shortlisted Nominees)
      </Typography>
      <Grid item xs={12} md={12} display={"flex"} flexWrap={"wrap"}>
        {civicNominees.map((nominate, index) => {
          const { name, title, imgpath } = nominate;
          return (
            <Grid
              key={index}
              item
              xs={12}
              md={3}
              marginBottom={{ xs: "7%", sm: "2%" }}
            >
              <Card
                sx={{
                  maxWidth: 260,
                  height: "100%",
                  borderTop: "10px solid #D7A036",
                }}
              >
                <CardActionArea>
                  <CardContent>
                    <Avatar
                      alt={name}
                      src={imgpath}
                      sx={{ width: 126, height: 126 }}
                    />
                    <Typography
                      gutterBottom
                      variant="h6"
                      color={"#004165"}
                      component="div"
                      textAlign={"center"}
                    >
                      {name}
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight={700}
                      color="#049593"
                      paragraph
                      textAlign={"center"}
                    >
                      {title}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default CivicNominees;
